// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	AddNoteButton: 'add-note-button',
	MatterNavNotesButton: 'matter-nav-notes-button',
	SelectPinnedNoteDiv: 'select-pinned-note-div',
	SelectUnpinnedNoteDiv: 'select-unpinned-note-div',
} as const;
